import {
  ColumnOrderState,
  OnChangeFn,
  functionalUpdate,
} from '@tanstack/react-table';
import { Dispatch, SetStateAction } from 'react';

import { ColumnOptionsModel } from './list-options-columns-step.controller';

export const createHideColumnHandler =
  <T extends ColumnOptionsModel>(
    setColumnOptions: Dispatch<SetStateAction<T>>,
  ) =>
  (columnId: string): void => {
    setColumnOptions((current) => ({
      ...current,
      columnVisibility: { ...current.columnVisibility, [columnId]: false },
    }));
  };

export const createColumnOrderChangeHandler =
  <T extends ColumnOptionsModel>(
    setColumnOptions: Dispatch<SetStateAction<T>>,
  ): OnChangeFn<ColumnOrderState> =>
  (updaterOrValue) => {
    setColumnOptions((current) => ({
      ...current,
      columnOrder: functionalUpdate(updaterOrValue, current.columnOrder),
    }));
  };
